import * as actionTypes from './action-types'
import LoginManager from '../managers/LoginManager'
import cachios from 'cachios'

// Add a response interceptor
cachios.axiosInstance.interceptors.response.use(function (config) {
    return config
}, LoginManager.responseInterceptor)

export default {
    /**
     * Check if account is completed of requires additional information
     * @param dispatch
     * @param commit
     * @param state
     * @param params
     * @returns {Promise<unknown>|Promise<void>}
     */
    [actionTypes.CHECK_ACCOUNT] ({ dispatch, commit, state }, params) {
        return LoginManager.checkAccountAction(params)
    },
    /**
     * Check if there is existing tokens/configurations/infos and use them where necessary
     * @param {Object} context.dispatch
     * @param {Object} context.commit
     * @param {Object} context.state
     * @param {Object} params
     */
    [actionTypes.CHECK_STORED_TOKENS] ({ dispatch, commit, state }, params) {
        LoginManager.checkStoredTokensAction(params)
    },
    /**
     * Check if the provider token is valid
     * @param dispatch
     * @param commit
     * @param state
     * @param params
     * @returns {Promise<unknown>}
     */
    [actionTypes.CHECK_USER_TOKEN_VALIDITY] ({ dispatch, commit, state }, params) {
        return LoginManager.checkUserTokenValidityAction(params)
    },
    /**
     * Connect Key Account Service (KAS) to KeyCloak
     * @param {Object} context.dispatch
     * @param {Object} context.commit
     * @param {Object} context.state
     * @param {Object} params
     */
    [actionTypes.GET_ACCOUNTS] ({ dispatch, commit, state }, params) {
        return LoginManager.getAccountsAction(params)
    },
    /**
     * Get configuration
     * @param {Object} context.dispatch
     * @param {Object} context.commit
     * @param {Object} context.state
     * @param {Object} params
     */
    [actionTypes.GET_CONFIGURATION] ({ dispatch, commit, state }, params) {
        LoginManager.getConfigurationAction(params)
    },
    /**
     * Get configuration settings
     * @param {Object} context.dispatch
     * @param {Object} context.commit
     * @param {Object} context.state
     * @param {Object} params
     */
    [actionTypes.GET_CONFIGURATION_SETTINGS] ({ dispatch, commit, state }, params) {
        LoginManager.getConfigurationSettingsAction(params)
    },
    /**
     * Get user infos
     * @param {Object} context.dispatch
     * @param {Object} context.commit
     * @param {Object} context.state
     * @param {Object} params
     */
    [actionTypes.GET_USER_INFOS] ({ dispatch, commit, state }, params) {
        return LoginManager.getUserInfosAction(params)
    },
    /**
     * Get user token
     * @param {Object} context.dispatch
     * @param {Object} context.commit
     * @param {Object} context.state
     * @param {Object} params
     */
    [actionTypes.GET_USER_TOKEN] ({ dispatch, commit, state }, params) {
        LoginManager.getUserTokenAction(params)
    },
    /**
     * Log in using User IS web service (used for legacy login mode)
     * @param dispatch
     * @param commit
     * @param state
     * @param params
     */
    [actionTypes.LOGIN] ({ dispatch, commit, state }, params) {
        LoginManager.loginAction(params)
    },
    /**
     * Log out user (for both legacy and kas login modes)
     * @param dispatch
     * @param commit
     * @param state
     * @param params
     */
    [actionTypes.LOGOUT] ({ dispatch, commit, state }, params) {
        LoginManager.logoutAction(params)
    },
    /**
     * Refresh user token
     * @param dispatch
     * @param commit
     * @param state
     * @param params
     */
    [actionTypes.REFRESH_TOKEN] ({ dispatch, commit, state }, params) {
        LoginManager.refreshTokenAction(params)
    },
    /**
     * Call a web service to activate user account deletion recognition
     * @param dispatch
     * @param commit
     * @param state
     * @param params
     */
    [actionTypes.SYNC_UNREGISTER] ({ dispatch, commit, state }, params) {
        LoginManager.syncUnregisterAction(params)
    },
    /**
     * Call a web service to activate user login recognition
     * @param dispatch
     * @param commit
     * @param state
     * @param params
     */
    [actionTypes.SYNC_LOGIN] ({ dispatch, commit, state }, params) {
        LoginManager.syncLoginAction(params)
    },
    /**
     * Call a web service to activate user logout recognition
     * @param dispatch
     * @param commit
     * @param state
     * @param params
     */
    [actionTypes.SYNC_LOGOUT] ({ dispatch, commit, state }, params) {
        LoginManager.syncLogoutAction(params)
    },
    /**
     * Call a web service to activate user refresh recognition
     * @param dispatch
     * @param commit
     * @param state
     * @param params
     */
    [actionTypes.SYNC_REFRESH] ({ dispatch, commit, state }, params) {
        LoginManager.syncRefreshAction(params)
    },
    /**
     * Call a web service to synchronize user status between client and server sides
     * @param dispatch
     * @param commit
     * @param state
     * @param params
     */
    [actionTypes.SYNC_USER_STATUS] ({ dispatch, commit, state }, params) {
        LoginManager.syncUserStatusAction(params)
    },
    /**
     * Unregister
     * @param {Object} context.dispatch
     * @param {Object} context.commit
     * @param {Object} context.state
     * @param {Object} params
     */
    [actionTypes.UNREGISTER] ({ dispatch, commit, state }, params) {
        LoginManager.unregisterAction(params)
    }
}
